module.exports = __webpack_public_path__ + "img/img22.b40f9aa1.svg";